import { GivelifyLabel, GivelifyPaper } from "@givelify/ui";
import { styled } from '@mui/material';

export const TableHeaderLabel = styled(GivelifyLabel)(({
    fontSize: 12,
}));

const baseWrapperStyle = (theme, cols) => ({
    display: 'grid',
    rowGap: 24,
    gridTemplateColumns: cols,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(4, auto)',
    },
    '& > *': {
      textAlign: 'right',
    },
    padding: '24px 12px',
    backgroundColor: theme.legacy.colors.grey50,
});
  
export const DonationWrapper = styled(GivelifyPaper)(({ theme }) =>
    baseWrapperStyle(theme, 'repeat(5, auto)')
);

export const RefundWrapper = styled(GivelifyPaper)(({ theme }) =>
    baseWrapperStyle(theme, 'repeat(6, auto)')
);

export const MobileFirstRowHeader = styled(TableHeaderLabel)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        gridColumn: 'span 2',
        textAlign: 'left',
    },
}));

export const MobileFirstRowText = styled(GivelifyLabel)(({ theme }) => ({
    color: theme.legacy.colors.grey600,
    [theme.breakpoints.down('sm')]: {
        gridRow: 2,
        gridColumn: 'span 2',
        textAlign: 'left',
    },
}));

export const DonationDetailsHeader = styled(MobileFirstRowHeader)(({
    textAlign: 'left !important' as 'left',
}));

export const DonationDetailsText = styled(MobileFirstRowText)(({ theme }) => ({
    color: theme.legacy.colors.grey600,
    textAlign: 'left !important' as 'left',
}));

export const EnvelopeNameHeader = styled(TableHeaderLabel)({
    textAlign: 'right',
});

export const EnvelopeNameLabel = styled(GivelifyLabel)(({ theme }) => ({
    color: theme.legacy.colors.grey600,
    gridColumn: 3,
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
        gridColumn: 1,
        textAlign: 'left !important' as 'left',
    },
}));

export const DonationResultLabel = styled(GivelifyLabel)(({ theme }) => ({
    gridColumn: 4,
    [theme.breakpoints.down('sm')]: {
        gridColumn: 2,
    },
}));

export const FeesResultLabel = styled(GivelifyLabel)(({ theme }) => ({
    gridColumn: 5,
    [theme.breakpoints.down('sm')]: {
        gridColumn: 3,
    },
}));

export const RefundAmountLabel = styled(GivelifyLabel)(({ theme }) => ({
    gridColumn: 6,
    [theme.breakpoints.down('sm')]: {
        gridColumn: 4,
    },
}));

export const TotalBorder = styled('div')(({ theme }) => ({
    height: 1,
    gridColumn: '1 / -1',
    background: theme.legacy.colors.grey200,
}));